export class Accessbtn {

    private clicked: boolean = false;
    private _state: boolean = false;
    private btn: HTMLElement | null;
    private paragraph: HTMLElement | null;

    constructor() {
        this.btn = document.querySelector('#access-btn');
        this.paragraph = document.querySelector('#access-btn > p');

        this.btn?.addEventListener('mouseenter', () => {
            if(!this.clicked) {
                this.state = !this.state;
            }
        });
        this.btn?.addEventListener('mouseleave', () => {
            if(!this.clicked) {
                this.state = !this.state;
            }
        });
        this.btn?.addEventListener('click', () => {
            this.clicked = !this.clicked;
            this.btnClicked();
        });
    }

    public set state(value: boolean) {
        this._state = value;

        if (this._state) {
            this.paragraph.innerHTML = 'dostępność: ON &nbsp;';

            this.btn.classList.toggle('switch-on');
        } else {
            this.paragraph.innerHTML = 'dostępność: OFF';

            this.btn.classList.toggle('switch-on');
        }
    }

    public btnClicked() {
        this.btn.classList.toggle('switch-clicked');
    }

    public get state(): boolean {
        return this._state;
    }
}
